var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href}},[_vm._v("Tweet This")])}
var staticRenderFns = []

export { render, staticRenderFns }